import React, { useEffect, useMemo, useRef, useState } from "react";
import Loader from "../../../components/loader/loader";
import SearchButton from "../../../components/inputs/searchButton";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import BreadCrumpBack from "../../../components/navigator/back";
import CustomIcons from "../../../components/icons/kIcons.component";
import { user_candidates_employed_list } from "../user.api";
import "../../../components/page/companyDirectory/compDirectory.style.css";

export default function EmployedDirectory(props) {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [qsearch, setQsearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const [isActive, setIsActive] = useState(true);
  const myRef = useRef(null);

  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance ? servInstance.substring(0, servInstance.length - 4) : "";

  const getCandidates = () => {
    setIsActive(true);
    user_candidates_employed_list()
      .then((res) => {
        setData(res?.data || []);
        setIsActive(false);
      })
      .catch((err) => {
        setIsActive(false);
      });
  };

  useEffect(() => {
    getCandidates();
  }, []);

  const searchChange = (e) => {
    const v = e.target.value;
    setSearch(v);
    setQsearch(v);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearch("");
    setQsearch("");
    setCurrentPage(1);
  };

  const filteredData = useMemo(() => {
    const query = qsearch.toLowerCase().trim();
    if (!query) return data;
    return data.filter(
      (item) =>
        (item?.name || "").toLowerCase().includes(query) ||
        (item?.company_name || "").toLowerCase().includes(query)
    );
  }, [data, qsearch]);

  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredData.slice(firstPageIndex, lastPageIndex);
  }, [filteredData, currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (myRef.current) {
      myRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    const computeSize = () => {
      const isLarge = typeof window !== "undefined" && window.innerWidth >= 1025;
      setPageSize(isLarge ? 6 : 6);
    };
    computeSize();
    window.addEventListener("resize", computeSize);
    return () => window.removeEventListener("resize", computeSize);
  }, []);

  const getPhotoUrl = (photo) => {
    if (!photo) return "";
    if (photo.startsWith("http")) return photo;
    return `${result}/${photo}`;
  };

  const isMalayalam = props.state.language === "ma";

  return (
    <div ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner">
          <div className="tit-txt">
            {isMalayalam
              ? "കെസ്പേസ് വഴി ജോലി ലഭിച്ച ഉദ്യോഗാർത്ഥികളുടെ ഡയറക്ടറി"
              : "Directory of Job Seekers Employed through KSPACE"}
          </div>
        </div>
      </div>
      <BreadCrumpBack />

      <div className="comp-layout-con">
        <div className="top-filter-wrap">
          <div className="filter-bar-actions">
            <div className="comp-search-box" style={{ flex: 1 }}>
              <SearchButton
                type="text"
                onChange={searchChange}
                clearSearch={clearSearch}
                value={search}
                placeholder={
                  isMalayalam
                    ? "പേര് അല്ലെങ്കിൽ കമ്പനി ഉപയോഗിച്ച് തിരയുക"
                    : "Search by Name or Company"
                }
                showSearchIcon={true}
              />
            </div>
          </div>
        </div>

        <div className="comp-outer-cont">
          <div className="com-dir-cont">
            <div className="comp-list-con">
              {mainData && mainData.length !== 0 ? (
                <>
                  {mainData.map((item) => (
                    <div key={item.id} className="comp-list-item-cont">
                      <div className="comp-list-item d-flex flex-column justify-content-between">
                        <div>
                          {/* Top Header Section */}
                          <div className="d-flex align-items-start gap-3 mb-3">
                            {item?.photo ? (
                              <div className="comp-item-logo">
                                <img
                                  className="comp-item-img-logo"
                                  alt=""
                                  src={getPhotoUrl(item.photo)}
                                />
                              </div>
                            ) : (
                              <div className="comp-item-logo placeholder">
                                {item?.name?.substring(0, 1).toUpperCase()}
                              </div>
                            )}

                            <div className="comp-item-header-info">
                              <div className="comp-item-comp-title mb-1">
                                {item.name
                                  ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                                  : ""}
                              </div>
                              <div className="comp-item-person-name" style={{ color: "#2f2483", fontWeight: "bold" }}>
                                <i className="fa fa-briefcase mr-1" style={{ opacity: 0.7 }}></i>
                                {isMalayalam ? "ജോലി ലഭിച്ച കമ്പനി: " : "Employed at: "}
                                {item.company_name || "-"}
                              </div>
                            </div>
                          </div>

                          {/* Contact Information List */}
                          <div className="comp-item-contact-list mb-3">
                            <div className="contact-detail-item">
                              <CustomIcons
                                iconName="mail"
                                iconClass="comp-item-data-icons"
                              />
                              <span className="contact-text text-break">{item.email || "-"}</span>
                            </div>

                            <div className="contact-detail-item">
                              <CustomIcons
                                iconName="phone"
                                iconClass="comp-item-data-icons"
                              />
                              <span className="contact-text text-break">{item.contact || "-"}</span>
                            </div>

                            {item.gender && (
                              <div className="contact-detail-item">
                                <CustomIcons
                                  iconName="people"
                                  iconClass="comp-item-data-icons"
                                />
                                <span className="contact-text text-break">
                                  {isMalayalam
                                    ? item.gender.toLowerCase() === "male"
                                      ? "പുരുഷൻ"
                                      : item.gender.toLowerCase() === "female"
                                        ? "സ്ത്രീ"
                                        : item.gender
                                    : item.gender}
                                </span>
                              </div>
                            )}

                            {item.address && (
                              <div className="contact-detail-item">
                                <CustomIcons
                                  iconName="globe"
                                  iconClass="comp-item-data-icons"
                                />
                                <span className="contact-text text-break">
                                  {item.address}
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="no-data-found w-100 text-center py-5">
                  {isMalayalam ? "വിവരങ്ങൾ ഒന്നും കണ്ടെത്തിയില്ല" : "No Results found"}
                </div>
              )}
            </div>
          </div>
        </div>

        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={filteredData.length}
          pageSize={pageSize}
          onPageChange={(page) => handlePageChange(page)}
        />
      </div>
    </div>
  );
}
